/**
 * The courses launched to the signed-in member, in the current organisation (12 Oct 2026).
 * Shared by the Courses page — whose My learning tab appears only when there is something in
 * it — and by a Learner's Courses page, which is nothing but this list.
 */
import { useEffect, useState } from 'react'
import { cachedMyLearning, orgApi, type LearningItem } from '@/lib/orgApi'

export function useMyLearning(orgId: string | null): { items: LearningItem[] | null; error: string } {
  // The last answer first, so the page doesn't wait on the server for it (24 Oct 2026); the fresh one
  // replaces it when it comes.
  const [state, setState] = useState<{ orgId: string | null; items: LearningItem[] | null; error: string }>(() => ({ orgId, items: cachedMyLearning(orgId), error: '' }))
  // A different organisation starts from its own last answer, or nothing (compared during render).
  if (state.orgId !== orgId) setState({ orgId, items: cachedMyLearning(orgId), error: '' })
  useEffect(() => {
    if (!orgId) return
    let off = false
    orgApi.myLearning(orgId)
      .then(r => { if (!off) setState({ orgId, items: r.items, error: '' }) })
      .catch(e => { if (!off) setState(prev => ({ orgId, items: prev.orgId === orgId ? prev.items : null, error: (e as Error).message })) })
    return () => { off = true }
  }, [orgId])
  return { items: state.items, error: state.error }
}
